export default __webpack_public_path__ + "static/media/finance-analytics.7a175fd6.png";